import { useAxiosQuery } from "../http/useAxiosQuery";
import { useHttp } from "../http/useHttp";
import { paths } from "../generated-types";

type UserDetailsOperation = paths["/dashboard/users/{api_token_uuid}"]["get"];
type UserDetailsPath = UserDetailsOperation["parameters"]["path"];
export type IUserDetails = UserDetailsOperation["responses"][200]["content"]["application/json"];
export type UseUserDetailsInput = { id?: UserDetailsPath["api_token_uuid"] };

export const useUserDetails = (input?: UseUserDetailsInput) => {
  const { client } = useHttp();
  const { status, isPending, isFetching, data, error, refetch } = useAxiosQuery<IUserDetails>({
    queryKey: ["user-details", input],
    queryFn: ({ signal }) => client.get(`/users/${input?.id}`, { signal }),
    enabled: Boolean(input && input.id),
  });

  return {
    user: data ? data.data : null,
    status,
    isPending,
    isFetching,
    error,
    refetch,
  };
};

export type UseUserDetailsReturn = ReturnType<typeof useUserDetails>;
